<template>
  <div class="security-device">
    <template v-if="step === 0">
      <img src="../../assets/images/device/pc_sigh.png" alt="" />
      <h3>安全验证</h3>
      <p>
        您正在一台新设备登录，为了您的账号安全，请进行安全验证
      </p>
    </template>
    <template v-else-if="step === 1">
      <div class="device-input-item">
        <el-input
          v-model="phone"
          placeholder="请输入您绑定的手机号"
          maxlength="11"
        ></el-input>
      </div>

      <div class="device-input-item sms-code">
        <el-input v-model="smsCode" placeholder="请输入短信验证码"></el-input>
        <el-button
          type="primary"
          @click="getCode"
          class="sms-code__btn"
          :disabled="!!count"
          >{{ count ? `${count}s` : '获取验证码' }}</el-button
        >
      </div>
    </template>
    <!-- <template v-else-if="step === 'payment'">
      <p class="payment-tips">
        由于您在一个新的IP登录游戏，为了您的资金安全，请您确认您的交易密码。
      </p>
      <el-input
        round
        v-model="phone"
        placeholder="请输入您的交易密码"
      ></el-input>
    </template> -->
    <el-button @click="vertify" class="security-device__btn" type="primary">{{
      step === 0 ? '开始验证' : '确认'
    }}</el-button>
  </div>
</template>

<script>
import utils from '@/utils/utils'

const TIME_COUNT = 60

export default {
  props: {
    account: String,
  },
  data() {
    return {
      step: 0,
      phone: '',
      count: 0,
      timer: null,
      smsCode: '',
    }
  },
  methods: {
    getCode() {
      if (this.count) return
      if (!utils.checkPhone(this.phone))
        return this.$message.error('手机号码校验失败')
      this.count = TIME_COUNT
      this.loopCount()
      this.$http
        .post(this.$api.sendValidateSmsCode, {
          mobile: this.phone,
          name: this.account,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message.success('获取验证码成功')
          } else {
            if(res.msg) this.$message({
              message: res.msg,
              type: 'error',
            })
            this.clearCount()
          }
        })
    },
    loopCount(){
      if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--
          this.timer = setTimeout(this.loopCount,1000)
      } else this.clearCount()
    },
    vertify() {
      if (this.step === 0) {
        return (this.step = 1)
      }
      if (this.step === 1) {
        if (!utils.checkPhone(this.phone))
          return this.$message.error('手机号码校验失败')
        if (!this.smsCode) return this.$message.error('短信验证码不能为空！')
        this.$http
          .post(this.$api.checkValidateSmsCode, {
            mobile: this.phone,
            name: this.account,
            smsCode: this.smsCode,
            fingerprint: this.$config.fingerprint,
            phoneModel: this.$config.phoneModel,
          })
          .then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '校验成功',
              })
              this.$emit('login')
            } else if(res.msg){
              this.$message({
                message: res.msg,
                type: 'error',
              })
              this.clearCount()
            }
          })
      }
    },
    clearCount() {
      clearTimeout(this.timer)
      this.count = 0
    },
  },
  beforeDestroy() {
    this.clearCount()
  },
}
</script>

<style lang="scss" scoped>
.security-device {
  text-align: center;
  position: relative;
  height: 360px;
  > img {
    display: block;
    margin: auto;
  }
  h3 {
    font-weight: 700;
    color: #333333;
    line-height: 42px;
    font-size: 30px;
    margin-top: 20px;
    margin-bottom: 17px;
  }
  p {
    color: #333333;
    font-size: 14px;
    height: 40px;
    max-width: 303px;
    margin: 0 auto;
    text-align: left;
  }
  &__btn {
    position: absolute;
    width: 270px;
    height: 40px;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 10px;
  }
  .device-input-item {
    width: 400px;
    margin: 0 auto 15px;
    &.sms-code {
      display: flex;

      .el-input {
        width: 280px;
      }
      .el-button {
        margin-left: auto;
        &[disabled] {
          &,
          &:hover,
          &:active {
            background: #f4f4f4;
            border-color: #f4f4f4;
            color: #ccc;
          }
        }
      }
      .sms-code__btn {
        min-width: 112px;
      }
    }
  }
  ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  .payment-tips {
    color: #f51c1c;
    font-size: 12px;
    max-width: unset;
    text-align: center;
  }
}
</style>
